module.exports = __webpack_public_path__ + "static/media/contactLeftShape.f3b44638.svg";